<ng-container *ngIf="report$ | async as report">
  <div class="saving-card is-relative">
    <div class="is-flex">
      <app-text class="is-family-semiBold text-18"> {{'💸 ' + ('common-app.__MY_ENERGY_SAVINGS' | AsyncLang | async)}}</app-text>
      <app-icon name="information" (click)="setInfo()" class="text-24 text-grey-50 has-spacing-left-s is-cursor-pointer"></app-icon>  
    </div>

    @if (isInfoOpen()) {
        <app-information-popup>
          <div role="content" class="content">
  
            <app-text
              class="text-18 is-family-semiBold has-spacing-bottom-xl is-justify-center"
              [text]="'bilan-energy.__SAVINGS_EUROS_TITLE' | AsyncLang | async">
            </app-text>
  
            <app-text class="text-14 is-justify-center"
              [text]="'bilan-energy.__SAVINGS_EUROS_EXPLANATION' | AsyncLang | async">
            </app-text>
            </div>
            <div role="footer" class="is-fullwidth" (click)="setInfo()">
              <app-text class="text-grey-70 text-16 is-family-semiBold is-cursor-pointer is-fullwidth is-justify-center"> {{'legrand-app.__LEG_UNDERSTOOD' | AsyncLang | async}}</app-text>
            </div>

        </app-information-popup>
     
    }
      <app-text *ngIf="report.savings_in_percentage < 0" >{{ 'bilan-energy.__SAVED_NEGATIVE_PERCENT' | AsyncLang | async }}</app-text>
      <ng-container  *ngIf="report.savings_in_percentage >= 0">
        <div class="progressbar">
          <div class="saving-progression" [ngStyle]="{'width': report.savings_in_percentage + '%', 'border-radius': report.savings_in_percentage >= 98 ? '8px' : ''}">
            <span class="saving-number text-22">{{ report.savings_in_percentage }}%</span>
          </div>
        </div>

        <div *ngIf="report.savings_in_percentage > 0" class="text-16 text-grey-70 is-family-semiBold has-spacing-bottom-xxl">{{ 'bilan-energy.__SAVED_IN_HOURS' | AsyncLang:[report.savings_in_percentage, getMonthText(report.month, report.year), report.savings_in_time] | async }}</div>
        <div *ngIf="report.savings_in_percentage === 0" class="text-16 text-grey-70 is-family-semiBold has-spacing-bottom-xxl">{{ 'bilan-energy.__SAVED_ZERO_PERCENT' | AsyncLang | async }}</div>

        <!-- schedule part -->
        <app-cp-reports-schedule-saving></app-cp-reports-schedule-saving>
        
          <div  *ngIf="getSaving(report) !== null">
            <div class="saving-part">
              <div [ngClass]="{ 'smaller-font': savingInMoneySmaller(report) }" class="saving-amout text-22 is-family-bold text-grey-80" >{{ getSaving(report) }}</div>
              <div class="saving-text text-14 text-grey-70 is-family-semiBold">{{ 'bilan-energy.__SAVINGS_IN_MONEY' | AsyncLang : [getSavingSentence(report)] | async }}</div>
            </div>
          </div>
      </ng-container>
    </div>
</ng-container>
